import Vue from 'vue';

export default {
  primary: function (titleMsg, callback, msg = { successMsg: '', errorMsg: "", }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$confirm(`您确定将选择的数据${titleMsg}吗?`, "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: 'confirm-button-blue'
      }).then(() => {
        if (callback) {
          callback();
        }
        if (msg.successMsg) {
          Vue.prototype.$message({
            type: "success",
            message: msg.successMsg,
          });
        }
        return resolve(true)
      }).catch(() => {
        if (msg.errorMsg) {
          Vue.prototype.$message({
            type: "info",
            message: msg.errorMsg,
          });
        }
        reject('errorMsg')
      })
    })

  },
  danger: function (titleMsg, callback, msg = { successMsg: '', errorMsg: "", }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$confirm(`您确定将选择的数据${titleMsg}吗?`, "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: 'confirm-button-red'
      }).then(() => {
        if (callback) {
          callback();
        }
        if (msg.successMsg) {
          Vue.prototype.$message({
            type: "success",
            message: msg.successMsg,
          });
        }
        return resolve(true)
      }).catch(() => {
        if (msg.errorMsg) {
          Vue.prototype.$message({
            type: "info",
            message: msg.errorMsg,
          });
        }
        reject('errorMsg')
      })
    })
  }

}